var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('news-entry',{attrs:{"title":'404 - ' + _vm.$t('notFound'),"text":_vm.$t('notFoundDetails')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }